import { useCallback } from 'react';
import { AUDIENCE_TYPE_DICT, AudienceType, EMPLOYEES } from 'shared/constants/audience-type';
import {
    useAllEntitiesExtendedWorkforce,
} from 'features/insights/hooks/extended-workforce/use-all-entities-extended-workforce';
import { capitalize } from 'lodash/fp';
import { getFeatureFlags } from 'core/flow-control';

/**
 * Hook that provides a function to get the correct label for an audience type
 */
export const useGetAudienceTypeLabels = () => {
    const areAllEntitiesExtendedWorkforce = useAllEntitiesExtendedWorkforce();
    const { enable_market_extended_workforce_v2_ff } = getFeatureFlags();
    return useCallback(
        (audienceType: AudienceType): string => {
            if (
                enable_market_extended_workforce_v2_ff &&
                areAllEntitiesExtendedWorkforce &&
                audienceType === EMPLOYEES
            ) {
                return 'Extended Workforce';
            } else {
                return AUDIENCE_TYPE_DICT[audienceType] || capitalize(audienceType);
            }
        },
        [areAllEntitiesExtendedWorkforce, enable_market_extended_workforce_v2_ff],
    );
};
